import React from 'react';

import classNames from 'classnames';

import { Button } from 'semantic-ui-react';

class ColoredButton extends React.Component {
  render() {
    const inheritedClasses = this.props.className ? this.props.className.split(' ') : '';
    const { className: _className, ...inheritedProps } = this.props;
    const buttonClasses = classNames(
      'custom-colored-button',
      inheritedClasses,
    );

    return (
      <Button className={buttonClasses} {...inheritedProps} />
    );
  }
}

export default ColoredButton;